import React from "react";
import dystoPunks from "../assets/dystopunks.jpg";
import y00ts from "../assets/y00ts.jpg";
import cyberkongz from "../assets/cyberkongz.jpg";
import sappySeals from "../assets/sappy-seals.jpg";
import yogaPetz from "../assets/yogapetz.jpg";
import aaveGotchi from "../assets/aavegotchi.jpg";
import coolCats from "../assets/cool-cats.jpg";

import "./Partnerships.scss";

const images = [
  dystoPunks,
  y00ts,
  cyberkongz,
  sappySeals,
  yogaPetz,
  aaveGotchi,
  coolCats,
  dystoPunks,
  y00ts,
  cyberkongz,
  sappySeals,
  yogaPetz,
  aaveGotchi,
  coolCats,
];

const Partnerships: React.FC = () => {
  return (
    <div className="partnerships">
      <div id="title" className="has-text-centered my-6">
        Supporting Communities
      </div>
      <div id="bodyText" className="has-text-centered my-6">
        We provide utility to all the holders of $CREDS, $DUST, $BANANA, $PIXL,
        $PRANA, $MILK, $GHST, $APE among others
      </div>
      <div className="carousels-container">
        <div className="carousel-wrapper">
          <div className="carousel">
            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt="partnership"
                className="carousel-image"
              />
            ))}
          </div>
          <div className="carousel">
            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt="partnership"
                className="carousel-image"
              />
            ))}
          </div>
        </div>
        <div className="carousel-wrapper-left">
          <div className="carousel">
            {images.reverse().map((img, index) => (
              <img
                key={index}
                src={img}
                alt="partnership"
                className="carousel-image"
              />
            ))}
          </div>
          <div className="carousel">
            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt="partnership"
                className="carousel-image"
              />
            ))}
          </div>
        </div>
      </div>
      <div id="bodyText" className="has-text-centered my-6">
        Burning the respective ERC-20 grants you unique benefits.
      </div>
    </div>
  );
};

export default Partnerships;
